import React from 'react';
import { PropTypes } from 'prop-types';
import { Pie } from 'react-chartjs-2';

const CAPPIE = (props) => {
    const {
        annualResults, selectedFinancing, doughnutSlider, projectState, sgipToggle,
    } = props;

    const doughYears = doughnutSlider;

    const annualUtilityPayment =
        annualResults[doughYears].formattedAnnualBill -
            annualResults[doughYears].annualSolarSavings >
        0
            ? annualResults[doughYears].formattedAnnualBill -
              annualResults[doughYears].annualSolarSavings
            : 0;

    const capVsUtilityCostPolar = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualSolarSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualCAPPayment
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].cashITC,
                    annualResults[doughYears].macrs,
                ],
                backgroundColor: ['#db4141', '#61ff9a', '#01B5D2', '#dfff61', '#ffe761'],
            },
        ],
        labels: ['Remaining Utility ($)', 'Solar Value ($)', 'Capital Lease ($) ', 'ITC ($)', 'MACRS ($)'],
    };

    const capVsUtilityCostPolarRECS = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualCAPPayment
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualSolarSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].cashITC,
                    annualResults[doughYears].macrs,
                    annualResults[doughYears].recs.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                ],
                backgroundColor: ['#db4141', '#61e9ff', '#61ff9a', '#dfff61', '#ffe761', '#FFAC33'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'Capital Lease ($) ',
            'Solar Value ($)',
            'ITC ($)',
            'MACRS ($)',
            'RECs ($)',
        ],
    };

    const capVsUtilityCostPolarSGIP = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualCAPPayment
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualSolarSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].cashITC,
                    annualResults[doughYears].macrs,
                    annualResults[doughYears].sgip,
                    annualResults[doughYears].sgipPBI,
                ],
                backgroundColor: ['#db4141', '#61e9ff', '#61ff9a', '#dfff61', '#ffe761', '#FFAC33', '#42f4c8', '#8641f4'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'Capital Lease ($) ',
            'Solar Value ($)',
            'ITC ($)',
            'MACRS ($)',
            'SGIP ($)',
            'SGIP PBI',
        ],
    };

    const capVsUtilityCostPolarSMART = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualCAPPayment
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualSolarSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].cashITC,
                    annualResults[doughYears].macrs,
                    annualResults[doughYears].smart,
                ],
                backgroundColor: ['#db4141', '#61e9ff', '#61ff9a', '#dfff61', '#ffe761', '#42f4c8'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'Capital Lease ($) ',
            'Solar Value ($)',
            'ITC ($)',
            'MACRS ($)',
            'SMART ($)',
        ],
    };

    const obsVsUtilityCostPolarNYCommercial = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualCAPPayment
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].annualSolarSavings
                        .toFixed(0)
                        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].cashITC,
                    annualResults[doughYears].nyserdaRebate,
                    annualResults[doughYears].cashNYAbatement,
                ],
                backgroundColor: ['#db4141', '#f243d8', '#61ff9a', '#dfff61', '#42f4c8', '#8334eb', '#eb34cc'],
            },
        ],
        labels: [
            'Remaining Utility ($)',
            'OBS ($) ',
            'Solar Value ($)',
            'ITC ($)',
            'NYSERDA Rebate',
            'Property Abatement',
        ],
    };

    let data = null;
    if (projectState === 3 && selectedFinancing === 5) {
        data = capVsUtilityCostPolarRECS;
    } else if (projectState === 1 && selectedFinancing === 5 && sgipToggle === true) {
        data = capVsUtilityCostPolarSGIP;
    } else if (projectState === 2 && selectedFinancing === 5) {
        data = capVsUtilityCostPolarSMART;
    } else if (projectState === 4 && selectedFinancing === 5) {
        data = obsVsUtilityCostPolarNYCommercial;
    } else {
        data = capVsUtilityCostPolar;
    }

    return (
        <div>
            {selectedFinancing === 5 ? (
                <li>
                    <Pie
                        height={345}
                        data={data}
                        options={{ maintainAspectRatio: true }}
                    />
                </li>
            ) : null}
        </div>
    );
};

CAPPIE.propTypes = {
    annualResults: PropTypes.object.isRequired,
    selectedFinancing: PropTypes.number.isRequired,
    doughnutSlider: PropTypes.number.isRequired,
    projectState: PropTypes.number.isRequired,
    sgipToggle: PropTypes.bool.isRequired,
};

export default CAPPIE;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/Graphs/CAPPIE/CAPPIE.js